import { Icons } from "@sembark-travel/ui-base"

export type EntryType =
	| "by_sheet"
	| "manually"
	| "ai_generated"
	| "by_preload"
	| undefined

function getEntryTypeConfig(entryType: EntryType, createdBy?: string) {
	const suffix = createdBy ? `\n by ${createdBy}` : ""

	const config = {
		by_sheet: {
			icon: Icons.Sheet,
			title: `Added by Sheet${suffix}`,
		},
		manually: {
			icon: Icons.HandPencil,
			title: `Added Manually${suffix}`,
		},
		ai_generated: {
			icon: Icons.SparklesSolid,
			title: "Added by AI",
		},
		by_preload: {
			icon: Icons.DataImport,
			title: `Added by AI Preload${suffix}`,
		},
	} as const

	return !entryType ? config.manually : (config[entryType] ?? config.manually)
}

export function EntryTypeIcon({
	entryType,
	createdBy,
}: {
	entryType: EntryType
	createdBy?: string
}) {
	const { icon: Icon, title } = getEntryTypeConfig(entryType, createdBy)
	return <Icon title={title} />
}
